// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3frw2","title":"FrontImage_title__2M_fz"};